export default function() {
    setTimeout(function(){
        $('#video-modalAbo').modal('show')
    }, 2000);

}